@if (submissionState === 'idle') {
  <mat-dialog-content class="update-collect__dialog">
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="onSubmit()" #collectNgForm="ngForm">
        <div class="update-collect__inputs">
          <div class="update-collect__info-inputs">
            <div class="update-collect__input-container">
              <mat-form-field appearance="fill" class="update-collect__input update-collect__input--stretch">
                <mat-label>Location</mat-label>
                <input
                  type="text"
                  #location
                  matInput
                  [matAutocomplete]="location_auto"
                  formControlName="location"
                  [ngClass]="{ 'is-success' : form.get('location').valid && form.get('location').dirty, 'is-danger' : !form.get('location').valid }"
                  aria-label="Location"
                  />
                <mat-autocomplete #location_auto="matAutocomplete" panelWidth="unset">
                  @for (location of filteredCollectLocations$ | async; track location) {
                    <mat-option [value]="location.name">
                      <img class="update-collect__example-option-img" aria-hidden [src]="location.logo" height="10">
                      <span>{{ location.name }}</span> |
                      <small>Floor: {{ location.floor }} | </small>
                      <small>Suite: {{ location.suite }}</small>
                    </mat-option>
                  }
                </mat-autocomplete>
                <mat-error [hidden]="form.get('location').valid" align="end">Location is required and must be from the list.</mat-error>
              </mat-form-field>
            </div>
            <div class="update-collect__input-container">
              <mat-form-field appearance="fill" class="update-collect__input update-collect__input--stretch">
                <mat-label>Collector Name</mat-label>
                <input
                  type="text"
                  #collector
                  matInput
                  [matAutocomplete]="collector_auto"
                  formControlName="collector"
                  [ngClass]="{'is-success' : form.get('collector').valid && form.get('collector').dirty, 'is-danger' : !form.get('collector').valid }"
                  aria-label="Collector"
                  >
                <mat-autocomplete #collector_auto="matAutocomplete" panelWidth="unset">
                  @for (collector of filteredCollectors$ | async; track collector) {
                    <mat-option [value]="collector.name">
                      <img class="update-collect__example-option-img" aria-hidden [src]="collector.icon" height="10">
                      <span>{{ collector.name }}</span>
                    </mat-option>
                  }
                </mat-autocomplete>
                <mat-error [hidden]="form.get('collector').valid" align="end">Collector is required and must be from the list</mat-error>
              </mat-form-field>
            </div>
            <div class="update-collect__input-container">
              <mat-form-field appearance="fill" class="update-collect__input update-collect__input--stretch">
                <mat-label>Waste Type</mat-label>
                <input
                  matInput
                  #waste_type
                  [matAutocomplete]="waste_type_auto"
                  type="text"
                  formControlName="waste_type"
                  [ngClass]="{'is-success' : form.get('waste_type').valid && form.get('waste_type').dirty, 'is-danger' : !form.get('waste_type').valid }"
                  aria-label="Waste Type"
                  >
                <mat-autocomplete #waste_type_auto="matAutocomplete" panelWidth="unset">
                  @for (waste_type of filteredWaste_Types$ | async; track waste_type) {
                    <mat-option [value]="waste_type.name">
                      <img class="update-collect__example-option-img" aria-hidden [src]="waste_type.icon" height="25">
                      <span>{{ waste_type.name }}</span>
                    </mat-option>
                  }
                </mat-autocomplete>
                <mat-error [hidden]="form.get('waste_type').valid" align="end">Waste type is required and must be from the list.</mat-error>
              </mat-form-field>
            </div>
            <div class="update-collect__input-container">
              <mat-form-field appearance="fill" class="update-collect__input update-collect__input--stretch">
                <mat-label>Vendor</mat-label>
                <input
                  matInput
                  #vendor
                  [matAutocomplete]="vendor_auto"
                  type="text"
                  formControlName="vendor"
                  [ngClass]="{'is-success' : form.get('vendor').valid && form.get('vendor').dirty, 'is-danger' : !form.get('vendor').valid }"
                  aria-label="Waste Type"
                  >
                <mat-autocomplete #vendor_auto="matAutocomplete" panelWidth="unset">
                  @for (vendor of filteredVendors$ | async; track vendor) {
                    <mat-option [value]="vendor.name">
                      <span>{{ vendor.name }}</span>
                    </mat-option>
                  }
                </mat-autocomplete>
                <mat-error [hidden]="form.get('vendor').valid" align="end">Vendor is required and must be from the list.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="update-collect__weight-inputs">
            @if (!usingVolume) {
              <div class="update-collect__input-container">
                <div class="update-collect__input-label">
                  Scale Weight
                </div>
                <mat-form-field appearance="fill" class="update-collect__scale-weight">
                  <input
                    matInput
                    #scale
                    type="number"
                    formControlName="scale_weight"
                    [ngClass]="{ 'is-success' : form.get('scale_weight').valid && form.get('scale_weight').dirty, 'is-danger' : !form.get('scale_weight').valid }"
                    aria-label="Scale Weight"
                    >
                  <mat-error [hidden]="form.get('scale_weight').valid" align="end">
                    The scale weight must be zero or greater. Add tare to the tare weight field.
                  </mat-error>
                  <span matSuffix class="update-collect__unit-suffix">{{ getScaleUnit() }}</span>
                </mat-form-field>
              </div>
            }
            <!-- Tare when weight is being measured -->
            @if (!usingVolume) {
              <div class="update-collect__input-container">
                <div class="update-collect__input-label">
                  Tare
                </div>
                <div class="update-collect__tare-inputs">
                  <mat-form-field appearance="fill" class="update-collect__input update-collect__input--slim">
                    <mat-label>Enter Container</mat-label>
                    <input
                      type="text"
                      #container
                      [matAutocomplete]="tare_auto"
                      formControlName="container"
                      matInput
                      [ngClass]="{'is-success' : form.get('container').valid && form.get('container').dirty, 'is-danger' : !form.get('container').valid }"
                      aria-label="Container"
                      >
                    <mat-autocomplete #tare_auto="matAutocomplete" panelWidth="unset">
                      @for (container of filteredContainers$ | async; track container) {
                        <mat-option [value]="container.name">
                          <img class="update-collect__example-option-img" aria-hidden [src]="container.icon" height="25">
                          <span>{{ container.name }}</span>
                        </mat-option>
                      }
                    </mat-autocomplete>
                    <mat-error [hidden]="form.get('container').valid" align="end">Tare container is required and must be from the list.</mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="fill" class="update-collect__tare-weight">
                    <input
                      #tare_weight
                      matInput
                      type="number"
                      formControlName="tare_weight"
                      [ngClass]="{'is-success' : form.get('tare_weight').valid && form.get('tare_weight').dirty, 'is-danger' : !form.get('tare_weight').valid }"
                      aria-label="Tare Weight"
                      >
                    <span matSuffix class="update-collect__unit-suffix">{{ getScaleUnit() }}</span>
                    <mat-error [hidden]="form.get('tare_weight').valid" align="end">Tare weight is required.</mat-error>
                  </mat-form-field>
                </div>
              </div>
            }
            <!-- Container when volume is being measured -->
            @if (usingVolume) {
              <div class="update-collect__input-container">
                <div class="update-collect__input-label">
                  Container
                </div>
                <div class="update-collect__tare-inputs">
                  <mat-form-field appearance="fill" class="update-collect__input">
                    <input
                      type="text"
                      #container
                      [matAutocomplete]="tare_auto"
                      formControlName="container"
                      matInput
                      [ngClass]="{'is-success' : form.get('container').valid && form.get('container').dirty, 'is-danger' : !form.get('container').valid }"
                      aria-label="Container"
                      >
                    <mat-autocomplete #tare_auto="matAutocomplete" panelWidth="unset">
                      @for (container of filteredContainers$ | async; track container) {
                        <mat-option [value]="container.name">
                          <img class="update-collect__example-option-img" aria-hidden [src]="container.icon" height="25">
                          <span>{{ container.name }}</span>
                        </mat-option>
                      }
                    </mat-autocomplete>
                    <mat-error [hidden]="form.get('container').valid" align="end">Container is required and must be from the list.</mat-error>
                  </mat-form-field>
                </div>
              </div>
            }
            <!-- Net weight when weight is being measured -->
            @if (!usingVolume) {
              <div class="update-collect__input-container">
                <div class="update-collect__input-label">
                  Net Weight
                </div>
                <mat-form-field appearance="fill" class="update-collect__net-weight">
                  <input
                    #net_weight
                    matInput
                    type="number"
                    formControlName="net_weight"
                    [ngClass]="{ 'is-success' : form.get('net_weight').valid && form.get('net_weight').dirty, 'is-danger' : !form.get('net_weight').valid }"
                    >
                  <span matSuffix class="update-collect__unit-suffix">{{ getScaleUnit() }}</span>
                  <mat-error [hidden]="form.get('net_weight').valid" align="end">Net weight should be equal to the scale weight minus the tare weight.</mat-error>
                </mat-form-field>
              </div>
            }
            <!-- Volume when volume is being measured -->
            @if (usingVolume) {
              <div class="update-collect__input-container">
                <div class="update-collect__input-label">
                  Volume
                </div>
                <mat-form-field appearance="fill" class="update-collect__net-weight">
                  <input
                    #volume
                    matInput
                    formControlName="volume"
                    >
                  <span matSuffix class="update-collect__unit-suffix">{{ containerUnitLabel() }}</span>
                </mat-form-field>
              </div>
            }
            <div class="update-collect__input-container">
              <div class="update-collect__input-label">
                Weighed At
              </div>
              <mat-form-field appearance="fill" class="update-collect__input update-collect__input--weighed-at">
                <input
                  matInput
                  #weighed_at
                  type="datetime-local"
                  formControlName="weighed_at"
                  [ngClass]="{'is-success' : form.get('weighed_at').valid && form.get('weighed_at').dirty, 'is-danger' : !form.get('weighed_at').valid }"
                  aria-label="Weighed At"
                  />
                <mat-error [hidden]="form.get('weighed_at').valid" align="end">Weighed at is required and must be in the past.</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="update-collect__actions-area">
          <button mat-flat-button color="accent" type="button" (click)="onSubmit()" [disabled]="form.invalid">Submit</button>
          <button mat-flat-button color="warn" type="button" (click)="deleteLastCollect()">
            Delete
          </button>
        </div>
      </form>
    }
  </mat-dialog-content>
}

@if (submissionState === 'success') {
  <mat-dialog-content>
    Success!
    &nbsp;&nbsp;
    <button mat-flat-button mat-dialog-close color="accent">
      OK
    </button>
  </mat-dialog-content>
}

@if (submissionState === 'error') {
  <mat-dialog-content>
    There was an issue updating the last entry
    <button mat-flat-button mat-dialog-close color="accent">
      OK
    </button>
  </mat-dialog-content>
}
